import { QuestionAnswerMap } from '@care-portals/api-interfaces';
import { GenericHeightWeightQuestionFieldAnswers } from '../../Generic/HeightWeight/question';

const SermorelinFollowupQuestions = [
  {
    field: 'sermorelinFollowup_sexAssignedAtBirth',
    label: 'What was your sex assigned at birth?',
    extras: { sendToBeluga: false },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Male',
          key: 'male'
        },
        {
          value: 'Female',
          key: 'female'
        }
      ]
    }
  },
  {
    field: 'sermorelinFollowup_pregnancyStatus',
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sermorelinFollowup_pregnancyConsent',
    label: 'Consent (Pregnancy Risk):',
    type: 'select',
    educationalSlide:
      'I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.\n\nI agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods as discussed with my healthcare provider.\n\nI understand that I should stop taking this medication before attempting to become pregnant. I agree to consult with my healthcare provider prior to discontinuing the medication and before planning a pregnancy to ensure my safety and well-being.\n\nBy selecting below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and do NOT wish to proceed',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read and understand the above information, I understand the risks and wish to proceed',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'sermorelinFollowup_height',
    label: 'What is your height in feet and inches?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'sermorelinFollowup_height'
    }
  },
  {
    field: 'sermorelinFollowup_weight',
    label: 'What is your weight in pounds?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'sermorelinFollowup_weight'
    }
  },
  {
    field: 'sermorelinFollowup_healthChanges',
    label:
      'Have there been any health changes, medication changes, ED visits or hospitalizations since your last check-in?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'No',
          key: 'no'
        },
        {
          value: 'Yes',
          key: 'yes'
        }
      ]
    }
  },
  {
    field: 'sermorelinFollowup_healthChangesDetails',
    label: 'Please tell us more about the changes in your health',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sermorelinFollowup_healthChangesDetails'
    }
  },
  {
    field: 'sermorelinFollowup_medicationDoing',
    label: 'How are you doing on the current medication?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Well',
          key: 'well'
        },
        {
          value: 'Not well',
          key: 'not_well'
        }
      ]
    }
  },
  {
    field: 'sermorelinFollowup_medicationExperience',
    label: 'Please tell us more about what you are experiencing',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sermorelinFollowup_medicationExperience'
    }
  },
  {
    field: 'sermorelinFollowup_activelyTaking',
    label: 'Are you still actively taking this medication?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'sermorelinFollowup_lastTaken',
    label: 'When did you last take this medication?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'sermorelinFollowup_lastTaken'
    }
  },
  {
    field: 'sermorelinFollowup_sideEffects',
    label: 'Have you had any side effects from the current medication?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'No',
          key: 'no'
        },
        {
          value: 'Yes',
          key: 'yes'
        }
      ]
    }
  },
  {
    field: 'sermorelinFollowup_sideEffectsDetails',
    label: 'Please tell us more about the side effects you are experiencing',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sermorelinFollowup_sideEffectsDetails'
    }
  },
  {
    field: 'sermorelinFollowup_diagnosedConditions',
    label:
      'Do you currently have, or have you ever been diagnosed with, any of the following conditions?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'None of these apply to me',
          key: 'none'
        },
        {
          value: 'Any Active Cancer',
          key: 'active_cancer'
        },
        {
          value: 'Hypothyroidism/Underactive Thyroid',
          key: 'hypothyroidism'
        }
      ]
    }
  },
  {
    field: 'sermorelinFollowup_thyroidControl',
    label: 'Is your thyroid disorder well controlled?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'sermorelinFollowup_thyroidControl'
    }
  },
  {
    field: 'sermorelinFollowup_thyroidControlConsent',
    type: 'select',
    label:
      'Sermorelin and tesamorelin can affect thyroid function by influencing how the body produces and converts thyroid hormones. If you have hypothyroidism or take thyroid medication, these treatments may alter your hormone levels or require adjustments to your thyroid dose. Monitoring thyroid function during therapy is recommended. Please report any changes in energy, mood, or temperature tolerance to your provider, as these may indicate a change in thyroid balance.',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the consent and I do NOT wish to move forward',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I wish to proceed and will discuss this medication with my doctor',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  //! This question is not being used, it is here for the backward compatibility
  {
    field: 'sermorelinFollowup_medications',
    label: 'Do you take any of the following medications?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'COX inhibitors (Aspirin, indomethacin)',
          key: 'cox_inhibitors'
        },
        {
          value: 'Muscarinic antagonist (atropine)',
          key: 'muscarinic_antagonist'
        },
        {
          value: 'Somatostatin-containing medications (clonidine and levodopa)',
          key: 'somatostatin'
        },
        {
          value: 'Propylthiouracil',
          key: 'propylthiouracil'
        },
        {
          value: 'None of the above',
          key: 'none'
        }
      ]
    }
  },
  {
    field: 'sermorelinFollowup_medications_new',
    label: 'Do you take any of the following medications?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Muscarinic antagonist (atropine)',
          key: 'muscarinic_antagonist'
        },
        {
          value: 'Somatostatin-containing medications (clonidine and levodopa)',
          key: 'somatostatin'
        },
        {
          value: 'Propylthiouracil',
          key: 'propylthiouracil'
        },
        {
          value: 'None of the above',
          key: 'none'
        }
      ]
    }
  },
  {
    field: 'sermorelinFollowup_additionalQuestions',
    label: 'What other information or questions do you have for the doctor?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'sermorelinFollowup_additionalQuestions'
    }
  },
  {
    field: 'sermorelinFollowup_consent',
    label: 'Consent:',
    type: 'select',
    educationalSlide:
      "Medications such as sermorelin and tesamorelin are medications that may be prescribed to support your metabolism, though it is not FDA-approved for this specific use. Its application for metabolism support is considered off-label, meaning it is prescribed by your healthcare provider despite not being specifically approved by the FDA for this purpose. The purpose of this consent form is to ensure that you understand the following:\n\n- The reasons for using sermorelin or tesamorelin\n- The potential benefits and risks\n- The monitoring plan\n- Your responsibilities during treatment\n\nPlease read this document carefully.\n\nSermorelin and tesamorelin are being considered as a treatment option to potentially improve your metabolic support by acting as a synthetic analogue of growth hormone-releasing hormone (GHRH), which stimulates the secretion of growth hormone (GH). Growth hormone plays a critical role in:\n\n- Growth\n- Body composition\n- Cell repair\n- Metabolism\n\nBy promoting the natural production of GH, these medications may provide the following benefits:\n\n- Enhance muscle growth\n- Improve body composition\n- Boost energy levels\n- Support overall physical performance\n\nIt is commonly used for purposes like weight loss, muscle gain, and anti-aging therapy.\n\nAs previously mentioned, the use of sermorelin and tesamorelin to increase growth hormone levels is considered off-label. While legally prescribed, its is not an FDA-approved indication.\n\nLike any medication, these comes with potential risks and side effects:\n\nCommon side effects:\n- Injection site reactions (pain, swelling, redness) if provided as an injection\n- Headaches\n- Flushing\n- Dizziness\n- Nausea\n\nLess common but more serious risks:\n- Exacerbation of undiagnosed cancers\n- Significant changes in blood pressure\n- Increased intracranial pressure\n- Severe allergic reactions\n\nThere are also concerns regarding the long-term use and its potential link to increased cancer risk. While there is no definitive evidence directly linking these to cancer, some studies suggest that prolonged use of growth hormone therapies could potentially increase the risk of certain cancers due to hormonal imbalances. Since these products stimulate the production of growth hormone, it may influence the development of cancerous cells in susceptible individuals.\n\nTo ensure safety and effectiveness, regular monitoring is required during treatment including:\n- Blood tests every six months to monitor growth hormone levels\n- Regular symptom assessments to evaluate the medication's effectiveness\n- Follow-up visits to discuss progress, side effects, and necessary adjustments to the treatment plan\n\nYou have the right to discuss and consider alternative treatments with your healthcare provider. These alternatives may include:\n- Lifestyle modifications (exercise, diet, sleep hygiene, stress management)\n\nAs a patient, you are responsible for:\n- Attending all scheduled follow-up appointments\n- Reporting any side effects or new symptoms to your healthcare provider\n- Adhering to the prescribed dosing regimen\n- Undergoing all required laboratory tests as part of the monitoring plan if needed\n\nBy selecting below, you confirm that you:\n- Have read and understood the information provided\n- Understand the potential risks and benefits of using sermorelin or tesamorelin, as well as its off-label nature\n- Agree to adhere to the monitoring plan and report any concerns or side effects to your healthcare provider",
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the consent and I do NOT wish to move forward',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the consent and understand the content, I wish to proceed',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'sermorelinFollowup_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'sermorelinFollowup_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    extras: { sendToBeluga: false },
    answer: {},
    reject: true,
    type: 'info',
    isLast: true
  },
  {
    class: 'ineligible',
    field: 'sermorelinFollowup_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    extras: { sendToBeluga: false },
    reject: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type SermorelinFollowupFieldAnswers = Partial<
  QuestionAnswerMap<typeof SermorelinFollowupQuestions>
> &
  GenericHeightWeightQuestionFieldAnswers;
export default SermorelinFollowupQuestions;
